import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../../Styles";
import { formatDisplayValue } from "../../helpers";

const KeyValueTable = ({
    t,
    rows = [],
    titleColumnLabel = "Title ",
    detailsColumnLabel = "Details",
    breakBefore = false,
    emptyMessage = "No data available",
}) => {
    const hasRows = rows.length > 0;

    const table = (
        <View style={styles.table}>
            <View style={styles.tableRow}>
                <View style={{
                    ...styles.tableColHeader,
                    ...styles.wordTableHeaderCell,
                }}>
                    <Text style={{
                        ...styles.tableCell,
                        ...styles.fontBold,
                        ...styles.wordTableHeaderText,
                    }}>
                        {t(titleColumnLabel)}
                    </Text>
                </View>
                <View style={{
                    ...styles.tableColHeader,
                    ...styles.wordTableHeaderCell,
                    ...styles.borderRightNone,
                }}>
                    <Text style={{
                        ...styles.tableCell,
                        ...styles.fontBold,
                        ...styles.wordTableHeaderText,
                    }}>
                        {t(detailsColumnLabel)}
                    </Text>
                </View>
            </View>

            {hasRows ? (
                rows.map((row, index) => {
                    const rowStyle = {
                        ...styles.tableRow,
                        ...(index === rows.length - 1 ? styles.tableLastRow : {}),
                    };

                    return (
                        <View style={rowStyle} key={`${row.title}-${index}`}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>
                                    {t(row.title)}
                                </Text>
                            </View>
                            <View style={{
                                ...styles.tableCol,
                                ...styles.borderRightNone,
                            }}>
                                <Text style={styles.tableCell}>
                                    {formatDisplayValue(row.details)}
                                </Text>
                            </View>
                        </View>
                    );
                })
            ) : (
                <View style={{
                    ...styles.tableRow,
                    ...styles.tableLastRow,
                }}>
                    <View style={styles.tableCol}>
                        <Text style={styles.tableCell}>
                            {t(emptyMessage)}
                        </Text>
                    </View>
                    <View style={{
                        ...styles.tableCol,
                        ...styles.borderRightNone,
                    }}>
                        <Text style={styles.tableCell}>-</Text>
                    </View>
                </View>
            )}
        </View>
    );

    if (breakBefore) {
        return <View break>{table}</View>;
    }

    return table;
};

export default withNamespaces()(KeyValueTable);
